import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import LanguageDetector from "i18next-browser-languagedetector";
import moment from "moment";
import 'moment/locale/he';

import en from './translates/en.json';
import he from './translates/he.json';
import React from "react";

const supportedLangKeys = ['en', 'he'];
const fallbackLng = 'en';

export function getTranslationLang() {
  const lang = i18n.language.split('-')[0];
  if (supportedLangKeys.some((l) => l === lang)) {
    return lang;
  }
  return fallbackLng;
}

i18n.on('languageChanged', (lng) => {
  const selectLanguage = lng.split('-')[0];
  const momentLang = supportedLangKeys.some((l) => l === selectLanguage) ? selectLanguage : fallbackLng;
  moment.locale(momentLang);
});

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    detection: {
      order: ['navigator', 'htmlTag', 'path', 'subdomain', 'localStorage'],
    },
    resources: {
      en,
      he
    },
    fallbackLng,
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });


export function withTypeTranslation(InputComponent) {
  return class extends React.Component {
    t2 = (type, key) => {
      let text = this.props.t(key + "." + type);
      if (!text.endsWith(type)) {
        return text;
      }
      text = this.props.t(key + ".default");
      if (!text.endsWith("default")) {
        return text;
      }
      return this.props.t(key)
    };

    render() {
      // Wraps the input component in a container, without mutating it. Good!
      return <InputComponent t2={this.t2} {...this.props} />;
    }
  }
}


export default i18n;



// WEBPACK FOOTER //
// ./src/app/i18n/index.js